import { Controller } from "@hotwired/stimulus"

// Loading state for inline notification action buttons (Retry, etc.).
// When clicked, swaps the button's icon for a spinner + disables the
// button. The turbo_frame response from the server then replaces the
// whole frame with the success/error chip (see
// _notification_action_result.html.erb), so this controller's job is
// just visual feedback during the in-flight POST.
//
// Per CLAUDE.md UX rules:
//   - e.preventDefault() FIRST
//   - flex layout already on the button
//   - form.requestSubmit() to actually fire the POST
export default class extends Controller {
  static targets = ["button", "icon", "label"]

  connect() {
    console.log("[notification-action] connect")
  }

  start(e) {
    console.log("[notification-action] start — submitting action")
    const button = this.hasButtonTarget ? this.buttonTarget : e.currentTarget
    const form = button.closest("form")
    if (!form) {
      console.warn("[notification-action] no enclosing form — letting click pass through")
      return
    }

    e.preventDefault()

    button.disabled = true
    button.classList.add("opacity-60", "pointer-events-none")
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = "..."
    }
    if (this.hasIconTarget) {
      this.iconTarget.outerHTML = `
        <svg class="w-3 h-3 shrink-0 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
      `
    }

    form.requestSubmit()
  }

  disconnect() {
    console.log("[notification-action] disconnect")
  }
}
